module.exports = __webpack_public_path__ + "fixelvariable-webfont.5cd63e3481ef4a98ae31.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fixelVariable/fixelvariable-webfont.woff2
// module id = ./src/assets/webfonts/fixelVariable/fixelvariable-webfont.woff2
// module chunks = styles